import DiallerButtonComponent from './DiallerButton.component';

export * from './DiallerButton.component';
export default DiallerButtonComponent;